import { Info } from "lucide-react";

export function AboutSection({ appName }) {
  return (
    <div className="card-base p-6">
      <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-4 flex items-center gap-2">
        <Info size={20} className="text-cyan-400" />
        About
      </h2>

      <div className="space-y-3 text-slate-400">
        <div className="flex justify-between">
          <span>App Name</span>
          <span className="text-white">{appName}</span>
        </div>
        <div className="flex justify-between">
          <span>Version</span>
          <span className="text-white">1.0.0</span>
        </div>
        <div className="flex justify-between">
          <span>Home Automation</span>
          <span className="text-amber-400">Mocked</span>
        </div>
      </div>
    </div>
  );
}
